import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "CampaignEditorLeftColumn" }
const _hoisted_2 = { class: "CampaignEditorRightColumn" }
const _hoisted_3 = {
  key: 0,
  class: "ValidationMessage ContentInvalid"
}
const _hoisted_4 = {
  key: 0,
  class: "InputDetailsMessage InputDetailsDisabledMessage"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DateStart = _resolveComponent("DateStart")!
  const _component_DateEnd = _resolveComponent("DateEnd")!
  const _component_LoadingWrapper = _resolveComponent("LoadingWrapper")!

  return (_openBlock(), _createBlock(_component_LoadingWrapper, {
    classes: ['CampaignEditorRow'],
    isLoading: _ctx.isLoading
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("label", {
          class: _normalizeClass([
				'CampaignEditorInputLabel',
				'DropdownLabel',
				'CampaignSettingsInputRequired',
				{ 'ContentInvalid': _ctx.isFieldValidatedAndMissing || _ctx.isFieldValidatedAndInvalid }
			])
        }, " Duration ", 2 /* CLASS */)
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_DateStart),
        _createVNode(_component_DateEnd),
        (_ctx.isFieldValidatedAndInvalid)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.validationInfoDates.message), 1 /* TEXT */))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", {
                class: _normalizeClass([
					'ValidationMessage',
					{ 'ContentInvalid': _ctx.isFieldValidatedAndMissing }
				])
              }, " This field must be completed before proceeding ", 2 /* CLASS */),
              (_ctx.datesDisabledMessage)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.datesDisabledMessage), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */))
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["isLoading"]))
}